export default __webpack_public_path__ + "d50ef09ab8a75435a58d4bfae547bd7a.png";